import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "flex flex-col p-6 overflow-hidden"
};
const _hoisted_2 = {
  class: "flex flex-col gap-4"
};
const _hoisted_3 = {
  class: "flex items-center justify-between gap-4"
};
const _hoisted_4 = {
  class: "flex items-center gap-3 overflow-hidden"
};
const _hoisted_5 = {
  key: 2,
  class: "text-base"
};
const _hoisted_6 = {
  class: "font-bold"
};
const _hoisted_7 = {
  key: 3,
  class: "text-base font-bold"
};
const _hoisted_8 = {
  class: "flex items-center justify-between [&:not(:has(:nth-child(2)))]:justify-center! gap-2 text-xs"
};
const _hoisted_9 = {
  class: "flex items-center justify-end flex-wrap gap-4 ml-auto"
};
const _hoisted_10 = {
  key: 0,
  class: "flex items-center gap-2 text-xs"
};
const _hoisted_11 = {
  class: "flex items-center gap-2 text-xs"
};
const _hoisted_12 = {
  key: 1,
  class: "flex items-center justify-end"
};
const _hoisted_13 = {
  class: "max-h-full w-full overflow-y-auto items-start gap-3 mt-6 text-xs border-t border-main-10"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
                                                        
  const _component_Button = _resolveComponent("Button");
                                                                          
                                                                
  const _component_Collapsible = _resolveComponent("Collapsible");
  const _directive_ptooltip = _resolveDirective("ptooltip");
  return _openBlock(), _createBlock(_component_Collapsible, {
    self: true
  }, {
    default: _withCtx(() => [$options.currentLog ? (_openBlock(), _createElementBlock("div", {
      key: $options.currentLog._id,
      class: _normalizeClass(["absolute left-1/2 bottom-0 -translate-x-1/2 max-md:w-full md:min-w-[650px] max-h-full max-w-3xl flex flex-col bg-white border border-second-50 shadow-[0_0_12px_2px_var(--color-second-100)] rounded-t-3xl transition-shadow duration-500 z-50 overflow-hidden", [{
        'hover:shadow-[0_0_20px_5px_var(--color-second-100)]': !_ctx.open
      }]]),
      onClick: _cache[2] || (_cache[2] = (...args) => $options.ToggleNotification && $options.ToggleNotification(...args))
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$options.currentLog.infoByStatus?.chip ? _withDirectives((_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["h-6 w-6 flex items-center justify-center rounded-full shrink-0", $options.currentLog.infoByStatus?.chip.class])
    }, [_createElementVNode("i", {
      class: _normalizeClass(["", $options.currentLog.infoByStatus?.chip.icon])
    }, null, 2)], 2)), [[_directive_ptooltip, $options.currentLog.infoByStatus.description]]) : _createCommentVNode("", true), !$options.currentLog.robotName ? (_openBlock(), _createBlock(_component_v_chip, {
      key: 1,
      color: "main",
      text: "Este robot ya no forma parte de nuestra familia",
      size: "x-small"
    })) : $options.currentLog.isNotification ? (_openBlock(), _createElementBlock("p", _hoisted_5, [_cache[3] || (_cache[3] = _createTextVNode("Se ha lanzado el robot ")), _createElementVNode("span", _hoisted_6, _toDisplayString($options.currentLog.robotName), 1)])) : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($options.currentLog.robotName), 1))]), _createElementVNode("div", {
      class: "h-8 w-8 flex items-center justify-center rounded-full shrink-0 border border-main-100 cursor-pointer",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => this.$state.ui.robotLogs.shift(), ["stop"]))
    }, _cache[4] || (_cache[4] = [_createElementVNode("i", {
      class: "icon-cross text-xs"
    }, null, -1)]))]), _createElementVNode("div", _hoisted_8, [$options.hasInfoMessages ? (_openBlock(), _createBlock(_component_v_chip, {
      key: 0,
      color: "main-50",
      text: _ctx.open ? 'Haz click para ver menos detalles' : 'Haz click para ver más detalles',
      size: "x-small"
    }, null, 8, ["text"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_v_chip, {
      color: $options.currentLog.scheduled ? 'cta' : 'second',
      text: $options.currentLog.executionType,
      size: "x-small"
    }, null, 8, ["color", "text"]), $options.currentLog.usedMachine ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[5] || (_cache[5] = _createElementVNode("i", {
      class: "icon-desktop text-base"
    }, null, -1)), _createElementVNode("p", null, _toDisplayString($options.currentLog.usedMachine.name), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_cache[6] || (_cache[6] = _createElementVNode("i", {
      class: "icon-calendar text-sm"
    }, null, -1)), _createTextVNode(" " + _toDisplayString($options.currentLog.createdAtString), 1)]), _ctx.$embedded && $options.currentLog.outputFileNames?.length && $options.currentLog.outputFileNames[0] != '' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_Button, {
      variant: "outlined",
      size: "xs",
      text: "Abrir carpeta",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.$desktopAppComunication('OpenFolder', $options.currentLog.outputFolder), ["stop"]))
    })])) : _createCommentVNode("", true)])])]), _createVNode(_component_Collapsible, {
      self: true
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_13, [_createVNode(_component_v_timeline, {
        side: "end",
        density: "comfortable",
        "truncate-line": "end"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.currentLog.normalizedUserLogStreams, msg => {
          return _openBlock(), _createBlock(_component_v_timeline_item, {
            key: msg,
            "dot-color": msg.color,
            size: "x-small"
          }, {
            opposite: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$formatDate({
              date: msg.timestamp,
              format: 'hh:mm:ss'
            })), 1)]),
            default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString(msg.text), 1)]),
            _: 2
          }, 1032, ["dot-color"]);
        }), 128))]),
        _: 1
      })], 512), [[_vShow, $options.hasInfoMessages && _ctx.open]])]),
      _: 1
    })])], 2)) : _createCommentVNode("", true)]),
    _: 1
  });
}

/* Vuetify */
import { VChip as _component_v_chip } from "vuetify/components/VChip"
import { VTimelineItem as _component_v_timeline_item, VTimeline as _component_v_timeline } from "vuetify/components/VTimeline"

